// eslint-disable
export function registerComponents(Vue) {
  Vue.component(
    'content-editor', require('./components/ContentEditor').default
  );

  Vue.component(
    'content-item-editor', require('./components/ContentItemEditor').default
  );

  Vue.component(
    'content-editor-classic', require('./components/ContentEditorClassic').default
  );

  Vue.component(
    'content-item-editor-classic', require('./components/ContentItemEditorClassic').default
  );

  Vue.component(
    'detail-navigation', require('./components/DetailNavigation').default
  );

  Vue.component(
    'guide-editor', require('./components/GuideEditor').default
  );

  Vue.component(
    'guide-item-editor', require('./components/GuideItemEditor').default
  );

  Vue.component(
    'guide-detail-navigation', require('./components/GuideDetailNavigation').default
  );

  Vue.component(
    'project-editor', require('./components/ProjectEditor').default
  );

  Vue.component(
    'project-detail-navigation', require('./components/ProjectDetailNavigation').default
  );

  Vue.component(
    'onair-description-navigation', require('./components/OnairDescriptionNavigation').default
  );

  Vue.component(
    'onair-description-editor', require('./components/OnairDescriptionEditor').default
  );
  
  Vue.component(
    'reward-editor', require('./components/RewardEditor').default
  );
  
  Vue.component(
    'reward-navigation', require('./components/RewardNavigation').default
  );
  
  Vue.component(
    'reward-set-list', require('./components/RewardSetList').default
  );
}
